import {
  PURCHASE_NETWORK_ICONS,
  PurchaseNetworkId,
} from './network-chain-icons';
import { QccContractChainKey } from './qcc-contract.config';

export type QccNetworkId = Exclude<PurchaseNetworkId, 'TRON'>;

export type QccBalanceChainMeta = {
  id: QccNetworkId;
  chainKey: QccContractChainKey;
  name: string;
  icon: string;
};

export const QCC_BALANCE_CHAINS: QccBalanceChainMeta[] = [
  {
    id: 'Base',
    chainKey: 'base',
    name: 'Base',
    icon: PURCHASE_NETWORK_ICONS.Base,
  },
  {
    id: 'BNB Chain',
    chainKey: 'bnb',
    name: 'BNB',
    icon: PURCHASE_NETWORK_ICONS['BNB Chain'],
  },
  {
    id: 'Polygon',
    chainKey: 'polygon',
    name: 'Polygon',
    icon: PURCHASE_NETWORK_ICONS.Polygon,
  },
  {
    id: 'Optimism',
    chainKey: 'optimism',
    name: 'Optimism',
    icon: PURCHASE_NETWORK_ICONS.Optimism,
  },
  {
    id: 'Arbitrum',
    chainKey: 'arbitrum',
    name: 'Arbitrum',
    icon: PURCHASE_NETWORK_ICONS.Arbitrum,
  },
  {
    id: 'Avalanche',
    chainKey: 'avalanche',
    name: 'Avalanche',
    icon: PURCHASE_NETWORK_ICONS.Avalanche,
  },
];

export function getQccChainKeyForNetwork(networkId: string): QccContractChainKey {
  const match = QCC_BALANCE_CHAINS.find(chain => chain.id === networkId);
  return match?.chainKey ?? 'base';
}
